namespace Matrix.Workflow {
    export interface ApprovalRetrieveResponse extends Serenity.ServiceResponse {
        WorkflowInstanceId?: number;
        QueueCode?: string;
        EntityType?: string;
        RecordKey?: string;
        OperationCode?: string;
        CreatedBy?: string;
        CreatedWhen?: string;
        StatusCode?: string;
        UpdatedWhen?: string;
        UpdatedBy?: string;
        FieldTitles?: { [key: string]: string };
        OldValues?: { [key: string]: any };
        NewValues?: { [key: string]: any };
        ExtraData?: { [key: string]: any };
        Request?: any;
        CanApprove?: boolean;
        CanReject?: boolean;
        ApproveCommentOption?: WorkflowCommentOption;
        RejectCommentOption?: WorkflowCommentOption;
        Comment?: string;
        ApproveRejectComment?: string;
    }
}
